import { RootState } from '../store';

export const selectUser = (state: RootState) => state.user.user;
export const selectUserEmail = (state: RootState) => state.user.user?.email;
export const selectUserName = (state: RootState) => state.user.user?.username;
export const selectUserId = (state: RootState) => state.user.user?.userId;
